import React from 'react';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import dayjs from 'dayjs';
import { formatNumberWithCommas } from '../../../../../tools/NumberTool';

const DeliveryTable = ({ tableData, setModalData }) => {
  return (
    <table>
      <thead>
        <tr>
          <th style={{ width: '80px' }}>배송완료일</th>
          <th>정산예정금 예정일</th>
          <th style={{ width: '125px' }}>
            배송완료 금액{' '}
            <button
              type="button"
              onClick={() => {
                setModalData({
                  textAlign: 'left',
                  fontWeight: 400,
                  contents: `'배송완료금액'은 배송 완료 상태로 확정 된 날짜를 기준으로 정산 예정일을 임의로 산출한 금액이므로, 참고용으로만 활용해 주세요.`,
                });
              }}
            >
              <FeatherIcon
                icon="help-circle"
                size={16}
                stroke="#737171"
                strokeWidth={2}
              />
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        {!tableData || tableData.length === 0 ? (
          <tr>
            <td colSpan={3} className="noList">
              <p>데이터가 없습니다.</p>
            </td>
          </tr>
        ) : (
          tableData?.map((row, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'center' }}>{row.deliverySuccessDate}</td>
              <td style={{ textAlign: 'center' }}>
                {dayjs(row.scheduledSettlementDate).format('YYYY-MM-DD')}
              </td>
              <td>{formatNumberWithCommas(row.deliverySuccessAmount)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default DeliveryTable;
